<section class="link-editor-page">
  <header class="page-header">
    <div>
      <p class="eyebrow">Link workspace</p>
      <h1>{{ pageTitle }}</h1>
      @if (siteName) {
        <p class="context-site">Viewing <strong>{{ siteName }}</strong></p>
      }
      <p class="intro">
        @if (siteName) {
          Manage the saved link details for {{ siteName }}.
        } @else {
          Manage the saved link details.
        }
      </p>
    </div>
    <a class="ghost" routerLink="/links">Back to links</a>
  </header>

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (!sites.length) {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Sites</p>
          <h2>No sites available</h2>
        </div>
        <a class="accent" routerLink="/sites">Manage sites</a>
      </header>
      <p class="empty-state">Create a site before opening the link editor.</p>
    </section>
  } @else if (loading) {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Loading</p>
          <h2>Preparing link workspace</h2>
        </div>
      </header>
      <p class="empty-state">Loading link...</p>
    </section>
  } @else if (link) {
    <section class="editor-panel">
      <div class="editor-grid">
        <label>
          <span>URL</span>
          <input [(ngModel)]="link.url" type="url" inputmode="url" spellcheck="false" placeholder="https://example.com" />
          @if (link.url.trim() && !hasValidUrl) {
            <span class="field-error">Enter a valid URL starting with http:// or https://.</span>
          }
          <div class="url-cleanup-actions">
            @if (cleanedYouTubeUrl) {
              <button type="button" class="ghost small clean-url-button" (click)="cleanYouTubeUrl()">
                Clean YouTube URL
              </button>
            }
            @if (cleanedTrackingUrl) {
              <button type="button" class="ghost small clean-tracking-url-button" (click)="cleanTrackingUrl()">
                Remove tracking codes
              </button>
            }
          </div>
        </label>

        <label>
          <span>Rating</span>
          <select [(ngModel)]="link.rating">
            @for (option of ratingOptions; track option.value) {
              <option [ngValue]="option.value">{{ option.label }}</option>
            }
          </select>
        </label>

        <label>
          <span>Headline</span>
          <input [(ngModel)]="link.headline" placeholder="Short title for this link" />
        </label>

        <label class="description-field">
          <span>Description (optional)</span>
          <textarea [(ngModel)]="link.description" rows="5" placeholder="Why this is useful"></textarea>
        </label>

        <div class="description-field">
          <cms-tag-selector
            [tags]="link.tags"
            [suggestions]="tagSuggestions"
            placeholder="Add link tags"
            (tagsChange)="link.tags = $event" />
        </div>
      </div>

      <div class="editor-actions">
        <button type="button" class="accent" [disabled]="saving || !canSubmitLink" (click)="saveLink()">
          {{ saving ? 'Saving...' : (isCreateMode ? 'Create link' : 'Save link') }}
        </button>
        @if (!isCreateMode) {
          <button type="button" class="danger" [disabled]="saving" (click)="deleteLink()">Delete link</button>
        }
      </div>
    </section>
  }
</section>
